import axios from "axios";
import heic2any from "heic2any";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const AllInventoryDetails = () => {
  // const jobs = useLoaderData();
  const { id } = useParams(); // Get the product ID from the URL params

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://server-gs.vercel.app/admin/products/${id}`
        );
        const data = await response.json();

        setProduct(data);
      } catch (error) {
        console.error("Failed to fetch product details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductDetails();
  }, [id]);

  ///////////////////////////////// EDIT START

  const [activeTab, setActiveTab] = useState(1);

  const [title, setTitle] = useState("");
  const [purchasePricing, setPurchasePricing] = useState("");
  const [flatFeePricing, setFlatFeePricing] = useState("");
  const [HourTime, setHourTime] = useState("");
  const [quantity, setQuantity] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [contractDescription, setContractDescription] = useState("");
  const [internalNotes, setInternalNotes] = useState("");
  const [images, setImages] = useState([]); // For multiple images
  const [singleImage, setSingleImage] = useState(null); // For single image
  const [video, setVideo] = useState(null);
  const [model, setModel] = useState(""); // For model field
  const [categories, setCategories] = useState([]); // To store categories from API
  const [SubCategoryMain, setSubCategoryMain] = useState([]); // To store SubCategoryMain from API
  const [selectedCategory, setSelectedCategory] = useState(""); // To store selected category
  const [selectedSubCategory, setSelectedSubCategory] = useState(""); // To store selected Event
  const [color, setColor] = useState(""); // To store selected Event
  const [height, setHeight] = useState(""); // For the numeric value of the height
  const [perDayPricing, setPerDayPricing] = useState(""); // For the numeric value of the height
  const [length, setLength] = useState(""); // For the numeric value of the height
  const [width, setWidth] = useState(""); // For the numeric value of the height
  const [unit, setUnit] = useState("ft");
  const [lengthUnit, setLengthUnit] = useState("");
  const [widthUnit, setWidthUnit] = useState("");
  const [shape, setShape] = useState("");
  const [showWebsite, setShowWebsite] = useState(false);
  const [productCode, setProductCode] = useState("");
  const [measurement, setMeasurement] = useState(""); // To store selected Event
  const [productLocation, setProductLocation] = useState("");
  const [Promotion, setPromotion] = useState(false);
  const [promotionValue, setPromotionValue] = useState("");
  const [promotionType, setPromotionValueType] = useState("%"); 
  const [isButtonLoading, setIsLoading] = useState(false);
  
  // Fetch categories and SubCategoryMain on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/all-main-category"
        );
        setCategories(response.data); // Assuming the data is an array of categories
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchSubCategoryMain = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/all-main-subCategory"
        );
        setSubCategoryMain(response.data); // Assuming the data is an array of SubCategoryMain
      } catch (error) {
        console.error("Error fetching SubCategoryMain:", error);
      }
    };

    fetchCategories();
    fetchSubCategoryMain();
  }, []);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://server-gs.vercel.app/admin/products/${id}`
        );
        const data = await response.json();

        setProduct(data);

        // Update state only if the data exists
        if (data) {
          setTitle(data.title || title); // Retain existing state if data is missing
          setPurchasePricing(data.purchasePricing || purchasePricing);
          setFlatFeePricing(data.flatFeePricing || flatFeePricing);
          setHourTime(data.HourTime || HourTime);
          setQuantity(data.quantity || quantity);
          setProductDescription(data.productDescription || productDescription);
          setContractDescription(
            data.contractDescription || contractDescription
          );
          setInternalNotes(data.internalNotes || internalNotes);
          setImages(data.images || images); // Retain existing images if data is missing
          setSingleImage(data.singleImage || singleImage); // Retain existing single image
          setVideo(data.video || video);
          setModel(data.model || model);
          setSelectedCategory(data.category || selectedCategory);
          setSelectedSubCategory(data.subCategory || selectedSubCategory);
          setColor(data.color || color);
          setHeight(data.height ? data.height.split(" ")[0] : height);
          setUnit(data.height ? data.height.split(" ")[1] : unit);
          setLength(data.length ? data.length.split(" ")[0] : length);
          setLengthUnit(data.length ? data.length.split(" ")[1] : lengthUnit);
          setWidth(data.width ? data.width.split(" ")[0] : width);
          setWidthUnit(data.width ? data.width.split(" ")[1] : widthUnit);
          setShape(data.shape || shape);
          setShowWebsite(data.showWebsite === "true" || showWebsite);
          setProductCode(data.productCode || productCode);
          setPerDayPricing(data.perDayPricing || perDayPricing);
          setMeasurement(data.measurement || measurement);
          setProductLocation(data.productLocation || productLocation);
          setPromotion(data.Promotion || Promotion);
          setPromotionValue(data.promotionValue || promotionValue);
          setPromotionValueType(data.promotionType || promotionType);
        }
      } catch (error) {
        console.error("Failed to fetch product details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductDetails();
  }, [id]);

  // Handle image selection

  // Handle form submission
  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const formData = new FormData();
    const combinedHeight = `${height} ${unit}`;
    const combinedLength = `${length} ${lengthUnit}`;
    const combinedWidth = `${width} ${widthUnit}`;

     // Find the selected category object
     const selectedCategoryObj = categories.find(cat => cat._id === selectedCategory);
     // Find the selected subcategory object (if exists)
     const selectedSubCategoryObj = SubCategoryMain.find(sub => sub._id === selectedSubCategory);

    // Append only updated fields
    if (title) formData.append("title", title);
    if (quantity) formData.append("quantity", quantity);
    if (purchasePricing) formData.append("purchasePricing", purchasePricing);
    if (flatFeePricing) formData.append("flatFeePricing", flatFeePricing);
    if (contractDescription)
      formData.append("contractDescription", contractDescription);
    if (productDescription)
      formData.append("productDescription", productDescription);
    if (internalNotes) formData.append("internalNotes", internalNotes);
    if (model) formData.append("model", model);
    if (perDayPricing) formData.append("perDayPricing", perDayPricing);
    if (showWebsite) formData.append("showWebsite", showWebsite);
     // Append category data (both ID and title)
     formData.append("category", selectedCategory);
     formData.append("categoryTitle", selectedCategoryObj?.title || "");
     
     // Append subcategory data (both ID and title if exists)
     formData.append("subCategory", selectedSubCategory);
     if (selectedSubCategoryObj) {
       formData.append("subCategoryTitle", selectedSubCategoryObj.title);
     } else {
       formData.append("subCategoryTitle", "");
     }
    if (height) formData.append("height", combinedHeight);
    if (length) formData.append("length", combinedLength);
    if (width) formData.append("width", combinedWidth);
    if (color) formData.append("color", color);
    if (shape) formData.append("shape", shape);
    if (productCode) formData.append("productCode", productCode);
    if (measurement) formData.append("measurement", measurement);
    if (productLocation) formData.append("productLocation", productLocation);
    if (Promotion) formData.append("Promotion", Promotion);
    if (promotionValue) formData.append("promotionValue", promotionValue);
    if (promotionType) formData.append("promotionType", promotionType);

    // Append existing images if they are not updated
    if (images.length === 0 && product?.images) {
      product.images.forEach((image) => {
        formData.append("existingImages", image);
      });
    } else {
      images.forEach((image) => {
        formData.append("images", image);
      });
    }

    // Append existing singleImage if no new singleImage is provided
    if (!singleImage && product?.singleImage) {
      formData.append("existingSingleImage", product.singleImage);
    } else {
      formData.append("singleImage", singleImage);
    }

    // Append video if it is updated
    if (video) {
      formData.append("video", video);
    }

    try {
      const response = await axios.put(
        `https://server-gs.vercel.app/update-inventory-products/${id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("Product updated successfully:", response.data);
      setIsLoading(false);
      Swal.fire({
        title: "Success!",
        text: "Product updated successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error updating product:", error);
      setIsLoading(false);
    }
  };

  // Function to handle tab switching
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [isDragging, setIsDragging] = useState(false);
  const [isDraggingImages, setIsDraggingImages] = useState(false);
  const [isLoadingSingleImage, setIsLoadingSingleImage] = useState(false); // Loading state for single image
  const [isLoadingImages, setIsLoadingImages] = useState(false); // Loading state for multiple images

  // Handle drag over for single image
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  // Handle drag leave for single image
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  // Handle file drop for single image
  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      await handleFile(file, setIsLoadingSingleImage, setSingleImage); // Handle the file (convert if necessary)
      e.dataTransfer.clearData();
    }
  };

  // Handle file selection for single image
  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      await handleFile(file, setIsLoadingSingleImage, setSingleImage); // Handle the file (convert if necessary)
    }
  };

  // Handle file processing (single or multiple)
  const handleFile = async (file, setIsLoading, setImageState) => {
    setIsLoading(true); // Start loading

    try {
      // Check if the file is HEIC/HEIF
      if (
        file.name.toLowerCase().endsWith(".heic") ||
        file.name.toLowerCase().endsWith(".heif")
      ) {
        // Convert HEIC to JPEG
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8, // Adjust quality as needed
        });

        // Create a new File object with the converted blob
        const convertedFile = new File(
          [convertedBlob],
          file.name.replace(/\.heic$|\.heif$/i, ".jpeg"),
          {
            type: "image/jpeg",
          }
        );

        setImageState(convertedFile);
      } else {
        // If it's not HEIC, use the file as-is
        setImageState(file);
      }
    } catch (error) {
      console.error("Error processing file:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  // Handle file selection for multiple images
  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsLoadingImages(true); // Start loading

      const files = Array.from(e.target.files);
      const convertedFiles = await Promise.all(
        files.map(async (file) => {
          if (
            file.name.toLowerCase().endsWith(".heic") ||
            file.name.toLowerCase().endsWith(".heif")
          ) {
            // Convert HEIC to JPEG
            const convertedBlob = await heic2any({
              blob: file,
              toType: "image/jpeg",
              quality: 0.8, // Adjust quality as needed
            });
            return new File(
              [convertedBlob],
              file.name.replace(/\.heic$|\.heif$/i, ".jpeg"),
              {
                type: "image/jpeg",
              }
            );
          }
          return file;
        })
      );

      setImages((prevImages) => [...prevImages, ...convertedFiles]);
      setIsLoadingImages(false); // Stop loading
    }
  };

  // Handle file drop for multiple images
  const handleDropImages = async (e) => {
    e.preventDefault();
    setIsDraggingImages(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setIsLoadingImages(true); // Start loading

      const files = Array.from(e.dataTransfer.files);
      const convertedFiles = await Promise.all(
        files.map(async (file) => {
          if (
            file.name.toLowerCase().endsWith(".heic") ||
            file.name.toLowerCase().endsWith(".heif")
          ) {
            // Convert HEIC to JPEG
            const convertedBlob = await heic2any({
              blob: file,
              toType: "image/jpeg",
              quality: 0.8, // Adjust quality as needed
            });
            return new File(
              [convertedBlob],
              file.name.replace(/\.heic$|\.heif$/i, ".jpeg"),
              {
                type: "image/jpeg",
              }
            );
          }
          return file;
        })
      );

      setImages((prevImages) => [...prevImages, ...convertedFiles]);
      setIsLoadingImages(false); // Stop loading
    }
  };

  // Handle drag over for multiple images
  const handleDragOverImages = (e) => {
    e.preventDefault();
    setIsDraggingImages(true);
  };

  // Handle drag leave for multiple images
  const handleDragLeaveImages = () => {
    setIsDraggingImages(false);
  };

  // Remove an image from the multiple images list
  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };
  ///////////////////////////////// EDIT END

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!product) {
    return <p>No product found</p>;
  }

  return (
    <div className="bg-gray-50 min-h-screen pb-10">
      <div className="w-full py-6 px-6 border-b border-gray-200 mb-10">
        <h1 className="text-2xl font-semibold font-roboto text-gray-500">
          Inventory Details
        </h1>
      </div>
      <div className=" mx-auto w-[95%]">
        {/* Button navigation */}

        {/* Tab content */}
        <form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          className="bg-white p-8 rounded-lg shadow-lg"
        >
          <div>
            <div className="grid grid-cols-2 gap-8">
              {/* Left Column */}
              <div className="space-y-6">
                <div className="flex flex-col">
                  <label className="text-xl text-gray-800 font-roboto mb-2">
                    Title
                  </label>
                  <input
                    type="text"
                    value={title}
                    className="border border-gray-300 bg-white h-12 w-full rounded-lg mt-1 p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>

                
            <div className="grid grid-cols-2 gap-5">
  {/* Category Select */}
  <div className="flex flex-col">
    <label className="text-lg font-roboto text-black mb-2">
      Choose Category <span className="text-red-500">*</span>
    </label>
    <select
      value={selectedCategory}
      onChange={(e) => setSelectedCategory(e.target.value)}
      className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
      required
    >
      <option value="">Select a category</option>
      {categories.map((category) => (
        <option key={category._id} value={category._id}>
          {category.title}
        </option>
      ))}
    </select>
  </div>

  {/* Show Sub Category Select only if subcategories exist for the selected category */}
  {SubCategoryMain.some((sub) => sub.categoryObjectId === selectedCategory) && (
    <div className="flex flex-col">
      <label className="text-lg font-roboto text-black mb-2">Sub Category</label>
      <select
        value={selectedSubCategory}
        onChange={(e) => setSelectedSubCategory(e.target.value)}
        className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
      >
        <option value="">Select a Sub Category</option>
        {SubCategoryMain.filter((sub) => sub.categoryObjectId === selectedCategory).map((sub) => (
          <option key={sub._id} value={sub._id}>
            {sub.title}
          </option>
        ))}
      </select>
    </div>
  )}
</div>


                <div className="grid grid-cols-2 gap-5">
                  <div className="flex flex-col">
                    <label className="text-xl text-gray-800 font-roboto mb-2">
                      Quantity
                    </label>
                    <input
                      type="number"
                      value={quantity ?? ""}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow empty input for smooth deletion
                        if (value === "") {
                          setQuantity(null);
                          return;
                        }

                        // Convert to number and ensure it's non-negative
                        const numberValue = Number(value);
                        if (!isNaN(numberValue) && numberValue >= 0) {
                          setQuantity(numberValue);
                        }
                      }}
                      className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xl text-gray-800 font-roboto mb-2">
                      Per day pricing
                    </label>
                    <input
                      type="number"
                      value={perDayPricing ?? ""}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow empty input for smooth editing
                        if (value === "") {
                          setPerDayPricing(null);
                          return;
                        }

                        // Convert to number and ensure it's non-negative
                        const numberValue = Number(value);
                        if (!isNaN(numberValue) && numberValue >= 0) {
                          setPerDayPricing(numberValue);
                        }
                      }}
                      min="0"
                      className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-5">
                  <div className="flex flex-col">
                    <label className="text-xl text-gray-800 font-roboto mb-2">
                      Product Code
                    </label>
                    <input
                      type="text"
                      value={productCode}
                      className="border border-gray-300 bg-white h-12 w-full rounded-lg mt-1 p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      onChange={(e) => setProductCode(e.target.value)}
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-lg font-roboto text-gray-700 mb-2">
                      Product Location
                    </label>
                    <input
                      type="text"
                      value={productLocation}
                      onChange={(e) => setProductLocation(e.target.value)}
                      className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div className="flex items-center mt-4">
                  <label
                    htmlFor="toogleA"
                    className="flex items-center cursor-pointer"
                  >
                    <div className="relative">
                      <input
                        id="toogleA"
                        type="checkbox"
                        className="sr-only"
                        onChange={() => setShowWebsite(!showWebsite)}
                        checked={showWebsite}
                      />
                      <div className="w-10 h-6 bg-gray-300 rounded-full shadow-inner transition-colors duration-200"></div>
                      <div className="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-0 transition-transform duration-200"></div>
                    </div>
                    <div className="ml-3 text-gray-700 font-medium">
                      Show website!
                    </div>
                  </label>
                </div>

                {showWebsite && (
                  <div className="mt-4 p-4 border border-gray-300 rounded-lg bg-gray-50">
                    <h2 className="text-lg font-semibold text-gray-800">
                      This product is uploaded on the website
                    </h2>
                  </div>
                )}
                <div className="flex flex-col mt-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="Promotion"
                  checked={Promotion}
                  onChange={() => setPromotion(!Promotion)}
                  className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500 transition-colors"
                />
                <label
                  htmlFor="Promotion"
                  className="ml-3 text-black font-medium"
                >
                  Show Promotion
                </label>
              </div>

              {Promotion && (
                <div className="flex flex-col space-y-2 mt-2">
                  <label className="text-lg font-roboto text-black ">
                    Add Promotion Discount:
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      value={promotionValue}
                      onChange={(e) => setPromotionValue(e.target.value)}
                      className="border w-[30%] border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
                      placeholder="Enter promotion discount"
                    />

                    <select
                      value={promotionType}
                      onChange={(e) => setPromotionValueType(e.target.value)}
                      className="border border-gray-300 rounded-lg px-2 py-2 bg-white cursor-pointer focus:outline-none"
                    >
                      <option value="%">%</option>
                      <option value="$">$</option>
                    </select>
                  </div>
                </div>
              )}
            </div>

              </div>

              {/* Right Column */}
              <div className="space-y-6">
                <div>
                  <h1 className="font-roboto text-xl text-gray-800 mb-2">
                    Attributes
                  </h1>

                  <div className="overflow-x-auto border border-gray-300 rounded-lg">
                    <table className="w-full text-sm text-left text-gray-500">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3">
                            Attributes
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Value
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th
                            scope="row"
                            class="px-6 py-4 text-left font-medium text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            <label className="text-sm text-black font-roboto">
                              Color
                            </label>
                          </th>
                          <td class="px-6 py-4">
                            <input
                              className="border border-gray-700 bg-white h-10 w-full rounded p-2"
                              type="text"
                              value={color}
                              onChange={(e) => setColor(e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th
                            scope="row"
                            class="px-6 py-4 font-medium text-left text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            <label className="text-sm text-black font-roboto">
                              Height
                            </label>
                          </th>
                          <td class="px-6 py-4 flex flex-row gap-2">
                            <input
                              className="border border-gray-700 bg-white h-10 w-full rounded p-2"
                              type="number"
                              value={height ?? ""}
                              onChange={(e) => {
                                const value = e.target.value;

                                // Allow empty input for smooth deletion
                                if (value === "") {
                                  setHeight(null);
                                  return;
                                }

                                // Convert to number and ensure it's non-negative
                                const numberValue = Number(value);
                                if (!isNaN(numberValue) && numberValue >= 0) {
                                  setHeight(numberValue);
                                }
                              }}
                            />

                            <select
                              id="unit"
                              class="block w-20 p-2 mb-6 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              value={unit}
                              onChange={(e) => setUnit(e.target.value)}
                            >
                              <option selected>select</option>
                              <option value="ft">ft.</option>
                              <option value="in">in.</option>
                              <option value="cm">cm.</option>
                            </select>
                          </td>
                        </tr>
                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th
                            scope="row"
                            class="px-6 py-4 font-medium text-left text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            <label className="text-sm text-black font-roboto">
                              Length
                            </label>
                          </th>
                          <td class="px-6 py-4 flex flex-row gap-2">
                            <input
                              className="border border-gray-700 bg-white h-10 w-full rounded p-2"
                              type="number"
                              value={length ?? ""}
                              onChange={(e) => {
                                const value = e.target.value;

                                // Allow empty input for smooth deletion
                                if (value === "") {
                                  setLength(null);
                                  return;
                                }

                                // Convert to number and ensure it's non-negative
                                const numberValue = Number(value);
                                if (!isNaN(numberValue) && numberValue >= 0) {
                                  setLength(numberValue);
                                }
                              }}
                            />

                            <select
                              id="unit"
                              class="block w-20 p-2 mb-6 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              value={lengthUnit}
                              onChange={(e) => setLengthUnit(e.target.value)}
                            >
                              <option selected>select</option>
                              <option value="ft">ft.</option>
                              <option value="in">in.</option>
                              <option value="cm">cm.</option>
                            </select>
                          </td>
                        </tr>
                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th
                            scope="row"
                            class="px-6 py-4 font-medium text-left text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            <label className="text-sm text-black font-roboto">
                              Width
                            </label>
                          </th>
                          <td class="px-6 py-4 flex flex-row gap-2">
                            <input
                              className="border border-gray-700 bg-white h-10 w-full rounded p-2"
                              type="number"
                              value={width ?? ""}
                              onChange={(e) => {
                                const value = e.target.value;

                                // Allow empty input for smooth deletion
                                if (value === "") {
                                  setWidth(null);
                                  return;
                                }

                                // Convert to number and ensure it's non-negative
                                const numberValue = Number(value);
                                if (!isNaN(numberValue) && numberValue >= 0) {
                                  setWidth(numberValue);
                                }
                              }}
                            />

                            <select
                              id="unit"
                              class="block w-20 p-2 mb-6 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              value={widthUnit}
                              onChange={(e) => setWidthUnit(e.target.value)}
                            >
                              <option selected>select</option>
                              <option value="ft">ft.</option>
                              <option value="in">in.</option>
                              <option value="cm">cm.</option>
                            </select>
                          </td>
                        </tr>
                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th
                            scope="row"
                            class="px-6 py-4 font-medium text-left text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            <label className="text-sm text-black font-roboto">
                              Measurement
                            </label>
                          </th>
                          <td class="px-6 py-4">
                            <input
                              className="border border-gray-700 bg-white h-10 w-full rounded p-2"
                              type="text"
                              value={measurement}
                              onChange={(e) => setMeasurement(e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th
                            scope="row"
                            class="px-6 py-4 font-medium text-left text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            <label className="text-sm text-black font-roboto">
                              Shape
                            </label>
                          </th>
                          <td class="px-6 py-4 flex flex-row gap-2">
                            <select
                              id="shape"
                              class="block w-full p-2 mb-6 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              value={shape}
                              onChange={(e) => setShape(e.target.value)}
                            >
                              <option value="other" selected>
                                Other
                              </option>
                              <option value="rectangle" selected>
                                Rectangle
                              </option>
                              <option value="round" selected>
                                Round
                              </option>
                              <option value="square" selected>
                                Square
                              </option>
                              <option value="serpentine" selected>
                                Serpentine
                              </option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-5 mt-10">
              <div className="space-y-6">
                <div className="flex flex-col">
                  <label className="text-xl text-gray-800 font-roboto mb-2">
                    Contract description
                  </label>
                  <textarea
                    value={contractDescription}
                    onChange={(e) => setContractDescription(e.target.value)}
                    className="border text-justify border-gray-300 bg-white h-32 w-full rounded-lg mt-1 p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-xl text-gray-800 font-roboto mb-2">
                    Product description
                  </label>
                  <textarea
                    value={productDescription}
                    onChange={(e) => setProductDescription(e.target.value)}
                    className="border text-justify border-gray-300 bg-white h-32 w-full rounded-lg mt-1 p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-xl text-gray-800 font-roboto mb-2">
                    Internal Notes
                  </label>
                  <textarea
                    value={internalNotes}
                    onChange={(e) => setInternalNotes(e.target.value)}
                    className="border text-justify border-gray-300 bg-white h-32 w-full rounded-lg mt-1 p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  />
                </div>
              </div>
              <div className="space-y-6 h-full">
                <div className="flex flex-col ">
                  <label className="text-lg font-roboto text-gray-700 mb-2">
                    Upload Single Image
                  </label>
                  <div
                    className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                      isDragging
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-300"
                    }`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    {isLoadingSingleImage ? (
                      <div className="flex flex-col items-center">
                        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                        <p className="text-gray-500">Processing image...</p>
                      </div>
                    ) : singleImage ? (
                      <div className="flex flex-col items-center">
                        {singleImage instanceof File ||
                        singleImage instanceof Blob ? (
                          <img
                            src={URL.createObjectURL(singleImage)}
                            alt="Selected"
                            className="w-32 h-32 object-cover mb-4 rounded-lg"
                          />
                        ) : typeof singleImage === "string" ? (
                          <img
                            src={singleImage}
                            alt="Selected"
                            className="w-32 h-32 object-cover mb-4 rounded-lg"
                          />
                        ) : (
                          <p className="text-red-500">Invalid image file</p>
                        )}
                        <button
                          type="button"
                          onClick={() => setSingleImage(null)}
                          className="text-sm text-red-600 underline"
                        >
                          Remove Image
                        </button>
                      </div>
                    ) : (
                      <p className="text-gray-500">
                        Drag & drop a file here or click to select
                      </p>
                    )}
                    <input
                      type="file"
                      id="fileInput"
                      className="hidden"
                      onChange={handleFileChange}
                      accept="image/*, .heic, .heif"
                    />
                    <label
                      htmlFor="fileInput"
                      className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                    >
                      Browse File
                    </label>
                  </div>
                </div>
                <div className="flex flex-col h-[50%] mt-5">
                  <label className="text-lg font-roboto text-gray-700 mb-2">
                    Upload Multiple Images
                  </label>
                  <div
                    className={`border-2 border-dashed h-full rounded-lg p-8 text-center transition-colors ${
                      isDraggingImages
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-300"
                    }`}
                    onDragOver={handleDragOverImages}
                    onDragLeave={handleDragLeaveImages}
                    onDrop={handleDropImages}
                  >
                    {isLoadingImages ? (
                      <div className="flex flex-col items-center">
                        {/* Spinning Loader */}
                        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                        <p className="text-gray-500">Processing images...</p>
                      </div>
                    ) : images.length > 0 ? (
                      <div className="grid grid-cols-3 gap-4">
                        {images.map((image, index) => (
                          <div key={index} className="relative">
                            {/* Check if image is a File/Blob or a URL */}
                            {image instanceof File || image instanceof Blob ? (
                              <img
                                src={URL.createObjectURL(image)}
                                alt={`preview-${index}`}
                                className="w-full h-32 object-cover rounded-lg"
                              />
                            ) : (
                              <img
                                src={image}
                                alt={`preview-${index}`}
                                className="w-full h-32 object-cover rounded-lg"
                              />
                            )}
                            <button
                              type="button"
                              onClick={() => removeImage(index)}
                              className="absolute top-2 right-2 px-2 py-1 bg-red-500 text-white rounded-full"
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-gray-500">
                        Drag & drop files here or click to select
                      </p>
                    )}
                    <input
                      type="file"
                      id="fileInputImage"
                      className="hidden"
                      multiple
                      accept="image/*, .heic, .heif"
                      onChange={handleImageChange}
                    />
                    <label
                      htmlFor="fileInputImage"
                      className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                    >
                      Browse Files
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex justify-start mt-8">
            <button
              type="submit"
              className="bg-blue-600 w-56 text-white font-roboto px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
              disabled={isButtonLoading}
            >
              {isButtonLoading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 018 8h-4l3 3 3-3h-4a8 8 0 01-8 8v-4l-3 3 3 3v-4a8 8 0 01-8-8h4l-3-3-3 3h4z"
                    ></path>
                  </svg>
                  Loading...
                </>
              ) : (
                "Create"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AllInventoryDetails;
